var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("User Guide")]),_vm._l((9),function(i){return _c('pdf',{key:i,staticStyle:{"display":"inline-block","width":"75%"},attrs:{"src":"./guide.pdf","page":i}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }